/**
 * `LocationTypeId` values returned by CADY Core's locations API.
 * Studio locations are physical CADY studios; Roadshow locations are
 * the schedulable school-side entries that drive the school flow.
 */
export enum LocationTypeId {
  Studio = 1,
  Roadshow = 2
}
